export const TYPES = {
  OPERATION: 'OPERATION',
  MD: 'MD',
  SECTION: 'SECTION',
  WEBHOOK: 'WEBHOOK',
  MAIN_ENTITY: 'MAIN_ENTITY',
  CATEGORY: 'CATEGORY',
  EVENT: 'EVENT',
  PROPERTY: 'PROPERTY',
  TAG: 'TAG',
  ARTICLES_CATEGORY: 'ARTICLES_CATEGORY',
  CLIENT_EVENT: 'CLIENT_EVENT',
};
